import React, { Fragment } from "react";
import styled from "styled-components";
import Header from "containers/Header";
import Footer from "containers/Footer";
import WindowDimensionsProvider from "containers/WindowDimensions";
import Navigator from "../../components/Navigator";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0 auto;
  background: #edeee9;
`;

const Layout = ({ children }) => {
  return (
    <Fragment>
      <WindowDimensionsProvider>
        <Wrapper>
          <Header />
          <Navigator />
          <main>{children}</main>
          <Footer />
        </Wrapper>
      </WindowDimensionsProvider>
    </Fragment>
  );
};

export default Layout;



// WEBPACK FOOTER //
// ./src/containers/Layout/index.js